import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlertsvarService } from '../alertsvar.service';
import { SharedService } from 'src/app/services/shared.service';
import { AlertsService } from '../alerts-custom.service';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';
import { KeyValue } from '@angular/common';
import { distinct, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { getObjectDiff } from '@donedeal0/superdiff';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TimeZoneService } from 'src/app/services/time-zone.service';

@Component({
  selector: 'app-event-panel',
  templateUrl: './event-panel.component.html',
  styleUrls: ['./event-panel.component.scss']
})
export class EventPanelComponent {

  constructor(
    public alertvarservice : AlertsvarService,
    public sharedservice : SharedService,
    private alertservice : AlertsService,
    private toastservice : ToastService,
    public matdialog: MatDialog,
    private timezoneservice : TimeZoneService
    )
  {}

  @Output() updateSummary:EventEmitter<string> = new EventEmitter()

  dialogRef

  setActionInput

  deletedRecordCount:number = 0;

  @Output() countChange:EventEmitter<object> = new EventEmitter()

  @ViewChild('actionpanel') actionpanel: TemplateRef<any>;
  

  row={}

  @Input() 
  set data(value: any) {
      this.row = value
  }

  pageNumber = 1
  pageLength = 1
  itemPerPage = new FormControl(25)

  mat_events_spinner=false

  bulkMode=false
  totalAlertCount=0
  selectAll = new FormControl(false)

  alertsList=[]
  selectedAlerts=[]
  exemptedAlerts=[]

  $destroy: Subject<boolean> = new Subject();

  tableHeaders=[
    {
      "disp":"Alert Timestamp",
      "value":"alerttime",
      "sort":true,
      "order":"DESC"
    },
    {
      "disp":"Event Count",
      "value":"eventcount",
      "sort":false,
      "order":"ASC"
    },
    {
      "disp":"Analysis status",
      "value":"status",
      "sort":false,
      "order":"ASC"
    },
    {
      "disp":"Analyst",
      "value":"assigned_user",
      "sort":false,
      "order":"ASC"
    }
    
  ]



  ngOnInit(){
// console.log("Row =----> ",this.row)
    this.deletedRecordCount = 0;

// console.log(this.sharedservice.analystlist)


    this.getEvents(this.row)
  }

  ngAfterViewInit(){
    this.selectAll.valueChanges.pipe(takeUntil(this.$destroy)).subscribe(val=>{
// console.log(val)
      if(!val){
        this.removeAll()
        this.bulkMode = false
      }else{
        this.selecteAll()
        this.bulkMode = true
      }
    
    })

    this.itemPerPage.valueChanges.pipe(distinctUntilChanged(),takeUntil(this.$destroy)).subscribe(val => {
      this.resetAlertPagenumber()
      this.getEvents(this.row)
    })
  }

  resetAlertPagenumber(){
    this.pageNumber = 1
    this.pageLength = 1
  }

  getApplicableActions(status){
    
    let actionObj={}

    if (this.sharedservice.getCurrentUserId() == this.alertvarservice.alertAnalystFilter.value){
        let actions = this.sharedservice.actions.actions;
        Object.keys(actions).forEach(key=>{
          if(status == key && status !=0){
            actions[key].next.forEach(val=>{
              actionObj[val]=actions[val]
            })
          }else if(status == 0){
            Object.keys(actions).forEach(dat=>{
              if(!actions[dat].isDefault){
                actionObj[dat]=actions[dat]
              }
            })
          }
        })
    }
    else if(this.sharedservice.get_assign_others_alerts_state() == 1) {
      actionObj = {"3":this.sharedservice.actions.actions["3"]};
      
    }
   
    
    return actionObj? actionObj : []
  }

  actionClick(index,group,action){
    this.openEditPopup(this.actionpanel,index,group,action)
  }
  
  openEditPopup(template,index,group,action) {
    // this.alertvarservice.dedupId = alertId

    let obj = {"alerttime":group.alerttime,"seq_no":group.seq_no,"status":group.status}

    group["platform"] = this.row["platform"]
    group["timerange"]=this.row["timeRange"]
    group["selectedAlert"]=[obj]
    group["exemptedAlert"]=this.exemptedAlerts

    const dialogRef: MatDialogRef<any> = this.matdialog.open(template, {
      minWidth: '35vw',  
      minHeight: '30vh',
      // width:'30vw',
      // height:'30vh',
      disableClose:true
      // panelClass: 'resizable-dialog'
    });
  
    this.dialogRef = dialogRef
  
    this.alertvarservice.actionPanel = dialogRef
  
    this.setActionInput = {"group":group,"action":action,"alertId":this.row["alertId"]}
  
  
    // this.alertvarservice.dedupDialogRef = dialogRef
  
    this.dialogRef._afterClosed.subscribe(val=>{
// console.log(val)
// console.log(index)

// console.log(this.alertvarservice.alertStateFilter.value)

if(val?.post_status == 1){
  if(val?.refresh_status){
    this.updateSummary.emit("refresh")
  } else {
    if([3,5,6].includes(action.value) || (!this.alertvarservice.alertStateFilter.value.includes(action.value) && this.alertvarservice.alertStateFilter.value[0] != 'all')){
      this.alertsList.splice(index,1)

      // this.countChange.emit({"count":1,"add":false})
      this.deletedRecordCount += 1
      // console.log(this.totalAlertCount , this.alertsList.length)
      if (this.totalAlertCount - this.alertsList.length == 0){
        this.updateSummary.emit("refresh")
      }else if(!this.alertsList.length){
        if(this.pageNumber == this.pageLength){
          this.paginationClick(-1)
        }else{
          this.paginationClick(1)
        }
      }
    } else{
      this.alertsList[index].status = action.value
    }
  }
  
}
      // this.alertvarservice.dedupData = {"alertId":"","status":0}
      this.setActionInput={}
// console.log("Close")
    })

    
  
  }


  async getEvents(row){
    let userIndex = this.sharedservice.analystlist.findIndex(val=> val.disp == this.sharedservice.userName)
    let sort = {"field":"alerttime","order":"DESC"}

    this.tableHeaders.forEach(val=>{
      if(val.sort){
        sort.field=val.value,
        sort.order=val.order
      }
    })

    let reqObj={
      "alertId":row.alertId,
      "timerange":this.toDate(row.timeRange),
      "page":this.pageNumber,
      "itemperpage":this.itemPerPage.value,
      "platform":row.platform,
      // "status":this.alertvarservice.alertStatusSelectedIndex == 4 ? [] : [row.status],
      "status":this.alertvarservice.getStateFilterValue(),
      // "assigned_user":[this.sharedservice.analystlist[userIndex].value],
      // "assigned_user":[this.sharedservice.getCurrentUserId()],
      "assigned_user":[this.alertvarservice.getAnalystFilterValue()],
      "sort":sort
    }

// console.log("Req =----> ",reqObj)

    // let mockRes={
    //   "alertcount": 1,
    //   "eventList": [
    //     {
    //       "alerttime": 1787786887,
    //       "seq_no": 46334,
    //       "status": 0,
    //       "assigned_user": 1,
    //       "eventdetails": {
    //         "time": "2026-08-26 23:28:07",
    //         "srcip": "198.235.24.198",
    //         "dstip": "103.8.188.211",
    //         "dstport": 444,
    //         "service": "TCP",
    //         "sum_sentbyte": 44,
    //         "sum_rcvdbyte": 40
    //       },
    //       "eventcount": 1
    //     }
    //   ]
    // }

    this.mat_events_spinner=true
    this.deletedRecordCount = 0;
    await this.alertservice.alertsGet.postrequest(reqObj).then(val=>{
// console.log(val)
      this.totalAlertCount=val.alertcount
      this.alertsList=val.eventList
      this.pageLength=Math.ceil(val.alertcount/this.itemPerPage.value)
      this.addAccordian(this.alertsList)
      this.mat_events_spinner=false
    }).catch(err=>{
// console.log(err)
      // this.toastservice.ShowToaster('Failed to get alerts.','failure')
      this.mat_events_spinner=false
    })

  }

  toDate(metaDate: any) {
    let date=[this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.calculate_timerange(metaDate)[0]).format('YYYY-MM-DD HH:mm:ss'),this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.calculate_timerange(metaDate)[1]).format('YYYY-MM-DD HH:mm:ss')]
    return date
  }
  addAccordian(list){
    list.forEach(val=>{
      val["accordian"] = false
      if(this.selectAll.value){

        let value = true

        this.exemptedAlerts.forEach(dat=>{
          if(dat.seq_no == val.seq_no){
            value = false
          }
        })

        if(value){
          val["selected"] = true
        }else{
          val["selected"] = false
        }

       
      }else{
        val["selected"] = false

        let value = false

        this.selectedAlerts.forEach(dat=>{
          if(dat.seq_no == val.seq_no){
            value = true
          }
        })

        if(value){
          val["selected"] = true
        }else{
          val["selected"] = false
        }
      }
    })
  }

  removeAll(){
// console.log(this.alertsList)
    this.alertsList.forEach(val=>{
      val["selected"] = false
    })
// console.log(this.alertsList)

    this.selectedAlerts = []
    this.exemptedAlerts=[]
    this.bulkMode= false
  }

  selecteAll(){
    this.alertsList.forEach(val=>{
        val["selected"] = true
    })
    this.exemptedAlerts = []
    this.selectedAlerts = []
    this.bulkMode =true
  }
  
  groupClick(event,alert){


    let check = event.target as HTMLInputElement

// console.log(check.checked)
  if(check.checked){
    alert["selected"]=true
    let obj = {"alerttime":alert.alerttime,"seq_no":alert.seq_no,"status":alert.status}
    if(this.selectAll.value){
// console.log("Selected Alert")
// console.log("-> ",this.exemptedAlerts)
      this.exemptedAlerts.forEach((dat,index)=>{
        if(getObjectDiff(dat,obj).status == "equal"){
          this.exemptedAlerts.splice(index,1)
// console.log("Remove =----> ",this.exemptedAlerts)

        }
      })
    }else{
// console.log("Selected Alert Else")
      this.selectedAlerts.push(obj)
    }
    
    
  }else{
// console.log("unchecked")
    alert["selected"]=false
    let obj = {"alerttime":alert.alerttime,"seq_no":alert.seq_no,"status":alert.status}
    if(this.selectAll.value){
      this.exemptedAlerts.push(obj)
    }else{
      // console.log("Unchecked")
      this.selectedAlerts.forEach((dat,index)=>{
        if(getObjectDiff(dat,obj).status == "equal"){
          this.selectedAlerts.splice(index,1)
        }
      })
    }

    
  }
// console.log(this.selectedAlerts , this.selectAll.value)
  if(this.selectedAlerts.length > 1 || this.selectAll.value){
    this.bulkMode = true
  }else{
    this.bulkMode = false
  }
// console.log(this.selectedAlerts)

  }

  openActionPanel(index){
    this.alertsList[index].accordian = !this.alertsList[index].accordian
  }

  changeSort(head){
    this.tableHeaders.forEach(val=>{
      if(head.value == val.value){
        val.sort = true
        if(val.order == "ASC"){
          val.order = "DESC"
        }else{
          val.order = "ASC"
        }
      }
      else{
        val.sort = false
      }
    })
    this.getEvents(this.row)
  }

  async acknowledgeClick(event,index){
    this.selectedAlerts.push({"alerttime":event.alerttime,"seq_no":event.seq_no,"status":this.row["status"]})
// console.log(event)
// console.log(this.row)
    let status=this.getStatusFromTab()
    let reqObj={
      "alertId":this.row["alertId"],
      "platform":this.row["platform"],
      "timerange":this.toDate(this.row["timeRange"]),
      "selectedAlert":this.selectedAlerts,
      "exemptedAlert":this.exemptedAlerts,
      "bulk_action":this.selectAll.value,
      "assigned_user":event.assigned_user,
      "status":status,
      "action":1,
      "reason": null,
      "priority": null,
      "reassign": null
    }

    await this.alertservice.actionPost.postrequest(reqObj).then(val=>{
// console.log(val)
      // this.deletedRecordCount = this.deletedRecordCount + 1;
    }).catch(err=>{
// console.log(err)
    })

// console.log(reqObj)
  }


  async updateAction(event,index){
// console.log(event)
      if(event.event == "cancel"){

        // this.alertsList[index].accordian=false

        this.selectAll.setValue(false)
        this.selectedAlerts=[]
        this.exemptedAlerts=[]
        this.bulkMode = false
        this.removeAll()

      }else{
        this.mat_events_spinner=true
        await this.alertservice.actionPost.postrequest(event.request).then((val:any)=>{
// console.log(val)
          if(val?.status == 1){
           
// console.log("Status 1")
            // this.deletedRecordCount = this.deletedRecordCount + 1;
            let total_alert_count = this.selectedAlerts.length || this.totalAlertCount - this.exemptedAlerts.length


            if(this.bulkMode || this.selectAll.value){
              this.alertvarservice.actionUpdateToasterMsg(event.request.action,val.updated_rows,total_alert_count,true)
// console.log("BulkMode")
              this.bulkMode = false
              this.selectAll.setValue(false)
              this.updateSummary.emit("refresh")
              // this.alertvarservice.alertSummaryServerityFilter.setValue(this.alertvarservice.alertSummaryServerityFilter.value,{emitEvent:true})
              // setTimeout(() => {
                // this.getEvents(this.row)
              // }, 500);
              
              this.selectedAlerts=[]
              this.exemptedAlerts=[]
              
            }else{
              let status = this.alertvarservice.actionUpdateToasterMsg(event.request.action,val.updated_rows,1,false)  
              // console.log({status})
              if(status === 1) {
                this.updateSummary.emit("refresh")
              } else {
                // console.log(this.alertsList[index].status)
                this.alertsList[index].status = event.request.action
                this.alertsList[index].accordian=false
              }
              
              }
              
    // console.log("After API =----> ",this.alert_dedup_data)
    // console.log(this.multiSelect)
          }else{
            this.alertvarservice.createtoastmsg({
              "type":"error", 
              "text":this.alertvarservice.toaster_message_alerts.error.update_action
            })
          }
          this.mat_events_spinner=false
        }).catch(err=>{
    // console.log(err)
          this.mat_events_spinner=false
        })
      }
      
    
    }


  getStatusFromTab(){
    let status = []
    if(this.alertvarservice.alertStatusSelectedIndex == 0){
      status = [0]
    }else if(this.alertvarservice.alertStatusSelectedIndex == 1){
      status = [1]
    }else if(this.alertvarservice.alertStatusSelectedIndex == 2){
      status = [3]
    }else if(this.alertvarservice.alertStatusSelectedIndex == 3){
      status = [4]
    }else if(this.alertvarservice.alertStatusSelectedIndex == 3){
      status = []
    }
    return status
  }

  getUsername(value){
    let name=''
    let index = this.sharedservice.analystlist.findIndex(val=> val.value == value)
    name = this.sharedservice.analystlist[index].disp
    return name
  }

  getActionDisp(value){
    let disp =""
    Object.keys(this.sharedservice.actions.actions).forEach(val=>{
      if(val == value.toString()){
        disp = this.sharedservice.actions.actions[val].disp
      }
    })
    return disp
  }

 

  paginationClick(direction){
    if (!this.mat_events_spinner) {
      let pagevalue = this.pageNumber;
      if (direction == -1) {
        if (pagevalue > 1) {
          this.pageNumber = this.pageNumber - 1;
        }
      } else {
        if (pagevalue < this.pageLength) {
          this.pageNumber = this.pageNumber + 1;
          this.pageNumber = Math.floor(((this.pageNumber - 1) * this.itemPerPage.getRawValue() - this.deletedRecordCount) / this.itemPerPage.getRawValue()) + 1;
        }
      }
      
      this.getEvents(this.row)
    }
  }

  getActionData(event){
// console.log(event)
    let selectedAlert =[{"alerttime":event.alerttime,"seq_no":event.seq_no,"status":this.row["status"]}]
    let actionObj={
      "alert_info":{
        "alertId":this.row["alertId"],
        "platform":this.row["platform"],
        "timerange":this.toDate(this.row["timeRange"]),
        "selectedAlert":selectedAlert,
        "exemptedAlert":this.exemptedAlerts,
        "bulk_action":this.selectAll.value, 
        // "assigned_user":event.assigned_user,
        // "status":this.getStatusFromTab()
        "assigned_user":[this.sharedservice.getCurrentUserId()],
        "status":this.alertvarservice.getStateFilterValue()
      }
    }
    return actionObj
  }
  getMultiActionData(){
    

    let assigned_user = this.alertsList[0].assigned_user


    let actionObj={
      "alert_info":{
        "alertId":this.row["alertId"],
        "platform":this.row["platform"],
        "timerange":this.toDate(this.row["timeRange"]),
        "selectedAlert":this.selectAll.value ? [] :this.selectedAlerts,
        "exemptedAlert":this.selectAll.value ? this.exemptedAlerts : [],
        "bulk_action":this.selectAll.value,
        // "assigned_user":assigned_user,
        // "status":this.getStatusFromTab()
        "assigned_user":[this.sharedservice.getCurrentUserId()],
        "status":this.alertvarservice.getStateFilterValue()
      },
      "totalCount":this.selectAll.value ? this.row["alertcount"] : this.selectedAlerts.length
    }
    return actionObj
  }


  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  ngOnDestroy(){
    this.$destroy.next()
    this.$destroy.unsubscribe()
  }

}
